import { render, staticRenderFns } from "./contract-detail-card.vue?vue&type=template&id=76fb8e27&scoped=true"
import script from "./contract-detail-card.vue?vue&type=script&lang=js"
export * from "./contract-detail-card.vue?vue&type=script&lang=js"
import style0 from "./contract-detail-card.vue?vue&type=style&index=0&id=76fb8e27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fb8e27",
  null
  
)

export default component.exports